<template>
  <div class="ProfessionalsPrivacyPolicy">
    <el-button @click="backToLogin" type="primary" icon="el-icon-arrow-left">Back</el-button>
    <pre>

      TERMS OF SERVICE
      Last updated November 20, 2024

      AGREEMENT TO OUR LEGAL TERMS
      We are LEAPIN GROUP PTE. LTD. ("Company," "we," "us," "our"), a company registered in Singapore at 15 Beach Road, #05-08, Beach Centre, Singapore (189677).
      We operate the website https://app.unfolds.ai/ (the "Site"), as well as any other related products and services that refer or link to these legal terms (the "Legal Terms") (collectively, the "Services").

      LEAPIN GROUP provides a platform to connect Job Seekers with Job Coaches, offering tools and resources for career development, coaching, and personalized career guidance. Our Services aim to facilitate meaningful connections and empower users with actionable insights to advance their professional journeys.

      You can contact us by email at info@leapin.io or by mail to 15 Beach Road, #05-08, Beach Centre, Singapore (189677).

      These Legal Terms constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you"), and LEAPIN GROUP PTE. LTD., concerning your access to and use of the Services. You agree that by accessing the Services, you have read, understood, and agreed to be bound by all of these Legal Terms. IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND MUST DISCONTINUE USE IMMEDIATELY.

      Supplemental terms and conditions or documents that may be posted on the Services from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Legal Terms at any time and for any reason. We will alert you about any changes by updating the "Last updated" date of these Legal Terms. You waive any right to receive specific notice of each such change. It is your responsibility to periodically review these Legal Terms to stay informed of updates. You will be subject to, and will be deemed to have been made aware of and accepted, the changes in any revised Legal Terms by your continued use of the Services after the date such revised Legal Terms are posted.

      The Services are intended for users who are at least 18 years old. Persons under the age of 18 are not permitted to use or register for the Services.

      We recommend that you print a copy of these Legal Terms for your records.

      TABLE OF CONTENTS
      1.Our Services
      2.Intellectual Property Rights
      3.User Representations
      4.User Registration
      5.Software
      6.Prohibited Activities
      7.User-Generated Contributions
      8.Contribution License
      9.Social Media
      10.Third-Party Websites and Content
      11.Services Management
      12.Privacy Policy
      13.Copyright Infringements
      14.Term and Termination
      15.Modifications and Interruptions
      16.Governing Law
      17.Dispute Resolution
      18.Corrections
      19.Disclaimer
      20.Limitations of Liability
      21.Indemnification
      22.User Data
      23.Electronic Communications, Transactions, and Signatures
      24.Miscellaneous
      25.Contact Us

      1. Our Services
      We provide a platform that facilitates connections between Job Seekers and Job Coaches for career guidance and coaching. Services include:
      Profile creation for both roles.
      Tools for communication, booking, and session management.
      Matchmaking features to connect users based on preferences.
      Note: We do not guarantee employment, career success, or coaching outcomes.

      2. Intellectual Property Rights
      All materials, trademarks, and content on our platform (excluding user-generated content) are owned by LEAPIN GROUP PTE. LTD. or licensed for use. Users are granted a limited license to access and use the Services solely for personal and professional purposes.

      3. User Representations
      By using our platform, you agree:
      To provide accurate and up-to-date registration information.
      That you meet eligibility requirements (e.g., 18 years or older).
      That you will comply with all applicable laws and regulations.
      Job Coaches further represent that they possess the necessary qualifications to provide career guidance.

      4. User Registration
      Users must create an account by providing accurate personal or professional information. You are responsible for safeguarding your account credentials and ensuring the security of your account.

      5. Software
      Any software or applications provided as part of the Services are licensed, not sold. Users agree not to copy, modify, reverse-engineer, or distribute the software without our explicit consent.

      6. Prohibited Activities
      You may not:
      Use the platform for unlawful or unethical purposes.
      Impersonate another user or misrepresent qualifications.
      Harass, discriminate, or engage in inappropriate conduct.
      Interfere with the platform's operation through hacking or other malicious activities.

      7. User-Generated Contributions
      Users may upload content, including profiles, reviews, and messages. By doing so, you confirm that:
      You have the rights to share the content.
      The content is accurate, lawful, and does not infringe on others’ rights.

      8. Contribution License
      By submitting content, you grant us a worldwide, royalty-free license to use, reproduce, and display the content for the purpose of operating and improving our Services.

      9. Social Media
      Users can interact with our platform via third-party social media accounts. You agree to comply with all terms of use for these platforms.

      10. Third-Party Websites and Content
      Our Services may link to third-party websites or resources. We are not responsible for their content, accuracy, or practices.

      11. Services Management
      We reserve the right to modify or discontinue Services for any reason, without prior notice. Users are responsible for ensuring backups of any critical data.

      12. Privacy Policy
      Our Privacy Policy governs how we collect, use, and protect your personal data. Users are encouraged to review the policy for detailed information.

      13. Copyright Infringements
      We respect intellectual property rights and expect users to do the same. Report suspected infringements via our designated contact email.

      14. Term and Termination
      These Terms remain in effect as long as you use the Services. We may suspend or terminate accounts for violations of these Terms.

      15. Modifications and Interruptions
      We may update these Terms or interrupt Services for maintenance. Users will be notified of significant changes.

      16. Governing Law
      These Terms are governed by the laws of Singapore.

      17. Dispute Resolution
      Disputes will be resolved through arbitration in Singapore unless otherwise required by law.

      18. Corrections
      We may correct errors or inaccuracies in the platform without prior notice.

      19. Disclaimer
      The Services are provided "as-is" without warranties of any kind.

      20. Limitations of Liability
      We are not liable for indirect, incidental, or consequential damages arising from the use of our Services.

      21. Indemnification
      Users agree to indemnify us against claims or damages arising from their use of the platform.

      22. User Data
      We are not liable for the loss of user data. Users should back up important information independently.

      23. Electronic Communications, Transactions, and Signatures
      Your use of our platform constitutes consent to receive communications electronically.

      24. Miscellaneous
      These Terms constitute the entire agreement between you and LEAPIN GROUP PTE. LTD. If any part of these Terms is deemed invalid, the remaining provisions remain enforceable.

      25. Contact Us
      For questions about these Terms, please contact us:

      LEAPIN GROUP PTE. LTD.
      15 BEACH ROAD, #05-08
      BEACH CENTRE, SINGAPORE (189677)
      Email: info@leapin.io
    </pre>
    
  </div>
</template>

<script>
export default {
  name: 'ProfessionalsPrivacyPolicy',
  data() {
    return {

    }
  },
  mounted () {

  },
  methods: {
    backToLogin() {
      window.history.back();
    }
  }
}
</script>
<style lang="scss" scoped>
.ProfessionalsPrivacyPolicy {
  margin: 32px 0 0 32px;
  pre {
    white-space: pre-wrap;
    font-size: 15px;
  }
}
</style>